export const GET_HOTSPOTS = "GET_HOTSPOTS";
export const RESET_HOTSPOTS = "RESET_HOTSPOTS";
export const SET_HOTSPOTS_REQUEST_STATUS = "SET_HOTSPOTS_REQUEST_STATUS";
